import request from '@/util/request'

// 获取官网相关配置(产品列表)
// res:"Data": {
//       "ProductModels": [
//         {
//           "ProductId": 1,
//           "ProductName": "sample string 2",
//           "ProductPrice": 3.0
//         }
//       ]
//     }
export function getProducts() {
  return request({
    url: 'api/Protal/GetProtalSettings',
    method: 'get',
  })
}

// 获取付款二维码url
//res:"Data": {
//     "PayUrl": "sample string 1",
//     "Tips": "sample string 2",
//     "out_trade_no": "sample string 3"
//   }
export function getPayUrl(productId) {
  return request({
    url: 'api/Pay/GetPayUrl',
    method: 'get',
    params: { productId }
  })
}

// 获取订单是否已成功支付
//res:"Data"
export function getPayResult(out_trade_no) {
  return request({
    url: 'api/Pay/GetPayResult',
    method: 'get',
    params: { out_trade_no }
  })
}

